// types
import { MILLION_UNITS, MONEY_RANGE_MAX, MONEY_RANGE_STEP } from "../../components/Credential/AllAssignments/FiltersSidebar/FilterInputMode/constant";
import { FilterToggleState, FilterType, IMainGroup, IUICategory, NumberUnitType } from "../../types/assignment-filters";

export const LEGACY_POSITION_LOCATION_KEY = 'location';
export const POSITION_LOCATION_KEY = 'loc_raw';
export const ASSIGNMENT_SELECTED_CANDIDATES_ROLE_DURATION = 'assignment_selected_candidates_role_duration';
export const ASSIGNMENT_INDUSTRY_CODES_KEY = 'assignment_industry_codes';

export const DEFAULT_CAT_STATES: { [key: string]: IUICategory } = {
  // Project fields
  assignment_label: {
    id: 'assignment_label',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Label',
    section_id: 'assignment_label',
    enabled: true,
    icon: 'event',
    kw_prefix: 'assignment.label',
    search_field: 'assignment.label',
    filter_type: FilterType.MULTI_SELECT,
    multi_input_by_comma: true,
  },
  start_date: {
    id: 'start_date',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Start Date',
    section_id: 'start_date',
    enabled: true,
    icon: 'event',
    kw_prefix: 'assignment.start_date',
    filter_type: FilterType.DATE_RANGE
  },
  end_date: {
    id: 'end_date',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Year of Project Completion', // End Date
    section_id: 'end_date',
    enabled: true,
    icon: 'event',
    kw_prefix: 'assignment.end_date',
    filter_type: FilterType.DATE_RANGE
  },
  functional_area: {
    id: 'functional_area',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Functional Area',
    section_id: 'functional_area',
    enabled: true,
    icon: 'category',
    filter_type: FilterType.MULTI_SELECT,
    kw_prefix: 'assignment.functional_area',
    search_field: 'assignment.functional_area',
    enableBrowseAll: true,
  },
  capability: {
    id: 'capability',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Capability',
    section_id: 'capability',
    enabled: true,
    icon: 'category',
    filter_type: FilterType.MULTI_SELECT,
    kw_prefix: 'assignment.capability',
    search_field: 'assignment.capability',
  },
  // rra specific field
  rra_office: {
    id: 'rra_office',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'RRA Office',
    section_id: 'rra_office',
    enabled: true,
    icon: 'domain',
    filter_type: FilterType.MULTI_SELECT,
    kw_prefix: 'assignment.office_name',
    search_field: 'assignment.office_name'
  },
  billing_client_company: {
    id: 'billing_client_company',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Client Name (Billed)',
    section_id: 'billing_client_company',
    enabled: true,
    icon: 'domain',
    filter_type: FilterType.MULTI_SELECT,
    kw_prefix: 'assignment.billing_client_company.company_name',
    search_field: 'assignment.billing_client_company.company_name'
  },
  position_client: {
    id: 'position_client',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Client Name (Position)',
    section_id: 'position_client',
    enabled: true,
    icon: 'domain',
    filter_type: FilterType.MULTI_SELECT,
    kw_prefix: 'assignment.client_company.company_name',
    search_field: 'assignment.client_company.company_name'
  },
  role: {
    id: 'role',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Assignment/Position Title',
    section_id: 'role',
    enabled: true,
    icon: 'work',
    filter_type: FilterType.MULTI_SELECT,
    kw_prefix: 'assignment.title',
    search_field: 'assignment.title',
    ui_cat_wl: ['Current Role'],
  },
  [POSITION_LOCATION_KEY]: {
    id: POSITION_LOCATION_KEY,
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Position Location',
    section_id: POSITION_LOCATION_KEY,
    enabled: false,
    icon: 'location_on',
    filter_type: FilterType.MULTI_SELECT,
    kw_prefix: 'assignment.location_raw',
    search_field: 'assignment.location_raw',
  },
  position_assignment_region: {
    id: 'position_assignment_region',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Region (Position)',
    section_id: 'position_assignment_region',
    enabled: false,
    icon: 'location_on',
    filter_type: FilterType.MULTI_SELECT,
    kw_prefix: 'assignment.region',
    search_field: 'assignment.region',
  },
  position_client_location_company_hq: {
    id: 'position_client_location_company_hq',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Position Client Location (Company HQ)',
    section_id: 'position_client_location_company_hq',
    enabled: false,
    filter_type: FilterType.GROUPED_MULTI_SELECT,
    icon: 'location_on',
  },
  billing_client_location: {
    id: 'billing_client_location',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Billing Client Location',
    section_id: 'billing_client_location',
    enabled: false,
    filter_type: FilterType.GROUPED_MULTI_SELECT,
    icon: 'location_on',
  },
  assignment_client_company_region: {
    id: 'assignment_client_company_region',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Region (Company HQ)',
    section_id: 'assignment_client_company_region',
    enabled: false,
    icon: 'location_on',
    filter_type: FilterType.MULTI_SELECT,
    kw_prefix: 'assignment.client_company.region',
    search_field: 'assignment.client_company.region',
  },
  reporting_level: {
    id: 'reporting_level',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Reporting Level',
    section_id: 'reporting_level',
    enabled: true,
    icon: 'category',
    filter_type: FilterType.MULTI_SELECT,
    kw_prefix: 'assignment.reporting_level',
    search_field: 'assignment.reporting_level'
  },
  private_capital_type_client: {
    id: 'private_capital_type_client',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Private Capital Type',
    section_id: 'private_capital_type_client',
    enabled: true,
    icon: 'category',
    filter_type: FilterType.MULTI_SELECT,
    kw_prefix: 'assignment.details.PrivateEquityType',
    search_field: 'assignment.details.PrivateEquityType'
  },
  project_type: {
    id: 'project_type',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Project Type',
    section_id: 'project_type',
    enabled: true,
    icon: 'category',
    filter_type: FilterType.MULTI_SELECT,
    kw_prefix: 'assignment.type',
    search_field: 'assignment.type',
  },
  assignment_type: {
    id: 'assignment_type',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Assignment Type',
    section_id: 'assignment_type',
    enabled: true,
    icon: 'category',
    filter_type: FilterType.MULTI_SELECT,
    kw_prefix: 'assignment.assignment_type',
    search_field: 'assignment.assignment_type'
  },
  service_line_group: {
    id: 'service_line_group',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Service Line Group',
    section_id: 'service_line_group',
    enabled: true,
    icon: 'category',
    filter_type: FilterType.MULTI_SELECT,
    kw_prefix: 'assignment.service_line_group',
    search_field: 'assignment.service_line_group'
  },
  service_line_type: {
    id: 'service_line_type',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Service Line Type',
    section_id: 'service_line_type',
    enabled: true,
    icon: 'category',
    filter_type: FilterType.MULTI_SELECT,
    kw_prefix: 'assignment.service_line_type',
    search_field: 'assignment.service_line_type'
  },
  lead_consultant: {
    id: 'lead_consultant',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Lead Consultant',
    section_id: 'lead_consultant',
    enabled: true,
    icon: 'person',
    filter_type: FilterType.MULTI_SELECT,
    kw_prefix: 'assignment.team.lead.name',
    search_field: 'assignment.team.name'
  },
  // industry_code: {
  //   id: 'industry_code',
  //   toggle_state: FilterToggleState.MUST_HAVE,
  //   title: 'Industry Code',
  //   section_id: 'industry_code',
  //   enabled: true,
  //   icon: 'construction',
  //   filter_type: FilterType.MULTI_SELECT,
  //   kw_prefix: 'assignment.client_company.industry_code',
  //   search_field: 'company.industry.sub_categories'
  // },
  confidentiality: {
    id: 'confidentiality',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Confidentiality',
    section_id: 'confidentiality',
    enabled: true,
    icon: 'lock',
    filter_type: FilterType.MULTI_SELECT,
    kw_prefix: 'assignment.confidentiality',
    search_field: 'assignment.confidentiality'
  },
  status: {
    id: 'status',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Assignment Status',
    section_id: 'status',
    enabled: false,
    icon: 'star',
    filter_type: FilterType.MULTI_SELECT,
    kw_prefix: 'assignment.status',
    search_field: 'status'
  },
  // beacon person filters
  // RRA specifics
  person_hub: {
    id: 'person_hub',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Hub',
    section_id: 'person_hub',
    enabled: true,
    icon: 'location_on',
    filter_type: FilterType.MULTI_SELECT,
    kw_prefix: 'assignment.team.lead.office_name',
    search_field: 'assignment.team.office_name'
  },
  person_industry: {
    id: 'person_industry',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Industry',
    section_id: 'person_industry',
    enabled: true,
    icon: 'construction',
    filter_type: FilterType.MULTI_SELECT,
    kw_prefix: 'assignment.team.lead.industry',
    search_field: 'assignment.team.industry'
  },
  [ASSIGNMENT_INDUSTRY_CODES_KEY]: {
    id: ASSIGNMENT_INDUSTRY_CODES_KEY,
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'RRA Industry Codes',
    section_id: ASSIGNMENT_INDUSTRY_CODES_KEY,
    enabled: true,
    icon: 'category',
    filter_type: FilterType.MULTI_SELECT,
    enableBrowseAll: true,
  },
  assignment_industry: {
    id: 'assignment_industry',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'RRA PIC',
    section_id: 'assignment_industry',
    enabled: true,
    icon: 'construction',
    filter_type: FilterType.MULTI_SELECT,
    kw_prefix: 'assignment.industry',
    search_field: 'assignment.industry',
  },
  assignment_client_company_parent_company_name: {
    id: 'assignment_client_company_parent_company_name',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'RRA Parent Company (Position)',
    section_id: 'assignment_client_company_parent_company_name',
    enabled: true,
    icon: 'category',
    filter_type: FilterType.MULTI_SELECT,
    kw_prefix: 'assignment.client_company.parent_company_name',
    search_field: 'assignment.client_company.parent_company_name',
  },
  assignment_billing_client_company_parent_company_name: {
    id: 'assignment_billing_client_company_parent_company_name',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'RRA Parent Company (Billing)',
    section_id: 'assignment_billing_client_company_parent_company_name',
    enabled: true,
    icon: 'category',
    filter_type: FilterType.MULTI_SELECT,
    kw_prefix: 'assignment.billing_client_company.parent_company_name',
    search_field: 'assignment.billing_client_company.parent_company_name',
  },
  assignment_industry_practice: {
    id: 'assignment_industry_practice',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'RRA Practice',
    section_id: 'assignment_industry_practice',
    enabled: true,
    icon: 'category',
    filter_type: FilterType.MULTI_SELECT,
    kw_prefix: 'assignment.industry_practice',
    search_field: 'assignment.industry_practice',
  },
  assignment_industry_sector: {
    id: 'assignment_industry_sector',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'RRA Industry',
    section_id: 'assignment_industry_sector',
    enabled: true,
    icon: 'category',
    filter_type: FilterType.MULTI_SELECT,
    kw_prefix: 'assignment.industry_sector',
    search_field: 'assignment.industry_sector',
  },
  assignment_position_client_company_stock_index: {
    id: 'assignment_position_client_company_stock_index',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Client Company Stock Index (Position)',
    section_id: 'assignment_position_client_company_stock_index',
    enabled: true,
    icon: 'category',
    filter_type: FilterType.MULTI_SELECT,
    kw_prefix: 'assignment.client_company.stock_index',
    search_field: 'assignment.client_company.stock_index',
  },
  assignment_billing_client_company_stock_index: {
    id: 'assignment_billing_client_company_stock_index',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Client Company Stock Index (Billing)',
    section_id: 'assignment.billing_client_company.stock_index',
    enabled: true,
    icon: 'category',
    filter_type: FilterType.MULTI_SELECT,
    kw_prefix: 'assignment.billing_client_company.stock_index',
    search_field: 'assignment.billing_client_company.stock_index',
  },
  person_capability: {
    id: 'person_capability',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Capability',
    section_id: 'person_capability',
    enabled: true,
    icon: 'category',
    filter_type: FilterType.MULTI_SELECT,
    kw_prefix: 'assignment.team.lead.capability',
    search_field: 'assignment.team.capability'
  },
  person_region: {
    id: 'person_region',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Region',
    section_id: 'person_region',
    enabled: true,
    icon: 'location_on',
    filter_type: FilterType.MULTI_SELECT,
    kw_prefix: 'assignment.team.lead.region',
    search_field: 'assignment.team.region'
  },
  person_is_active: {
    id: 'person_is_active',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Lead Still at RRA',
    section_id: 'person_is_active',
    enabled: true,
    icon: 'notifications',
    filter_type: FilterType.BOOLEAN,
    kw_prefix: 'assignment.team.lead.active',
    search_field: 'team.lead.active'
  },
  // company filters
  company_by_id: {
    ui_cat_wl: ['Company By ID'],
    id: 'company_by_id',
    kw_prefix: 'workexp.current.company.id',
    title: 'Current Company By ID',
    section_id: 'company_by_id',
    enabled: false,
    icon: 'work',
    toggle_state: FilterToggleState.NICE_TO_HAVE,
    filter_type: FilterType.MULTI_SELECT
  },
  company_keyword: {
    id: 'company_keyword',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Keyword',
    section_id: 'company_keyword',
    enabled: true,
    icon: 'search',
    filter_type: FilterType.MULTI_SELECT,
    kw_prefix: 'assignment.client_company.description',
  },
  assignment_org_type: {
    ui_cat_wl: [],
    id: 'assignment_org_type',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Org Type',
    section_id: 'assignment_org_type',
    enabled: false,
    icon: 'category',
    kw_prefix: 'assignment.client_company.org_type',
    filter_type: FilterType.MULTI_SELECT,
    search_field: 'company.org_type'
  },
  company_biz_model: {
    id: 'company_biz_model',
    ui_cat_wl: [],
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Business Model',
    section_id: 'company_biz_model',
    enabled: false,
    icon: 'category',
    kw_prefix: 'assignment.client_company.biz_models',
    filter_type: FilterType.MULTI_SELECT,
    search_field: 'company.biz_models'
  },
  past_or_current_company_industry: {
    id: 'past_or_current_company_industry',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Findem Industry',
    section_id: 'past_or_current_company_industry',
    enabled: false,
    icon: 'category',
    kw_prefix: 'assignment.client_company.industry',
    filter_type: FilterType.MULTI_SELECT,
    search_field: 'assignment.client_company.industry'
  },
  company_competitors: {
    ui_cat_wl: [],
    id: 'company_competitors',
    kw_prefix: 'assignment.client_company.competitors.name',
    toggle_state: FilterToggleState.MUST_HAVE,
    enabled: true,
    title: 'Competitors',
    section_id: 'company_competitors',
    icon: 'category',
    filter_type: FilterType.MULTI_SELECT,
    search_field: 'company.company_name'
  },
  rra_company_size: {
    id: 'rra_company_size',
    toggle_state: FilterToggleState.MUST_HAVE,
    kw_prefix: 'assignment.client_company.comp_size',
    title: 'Company Size',
    section_id: 'Work_Experience',
    enabled: false,
    icon: 'category',
    filter_type: FilterType.NUMBER_RANGE,
  },
  rra_revenue: {
    ui_cat_wl: ['CapIQ', 'Revenue'],
    id: 'rra_revenue',
    toggle_state: FilterToggleState.MUST_HAVE,
    // kw_prefix: 'workexp.current.ciq.company.curr_financial_info.revenue',
    kw_prefix: 'assignment.client_company.revenue',
    title: 'Company Revenue',
    section_id: 'rra_revenue',
    enabled: false,
    icon: 'store',
    filter_type: FilterType.NUMBER_RANGE,
    unit: NumberUnitType.money
  },
  assignment_client_company_rra_candid_est_revenue: {
    id: 'assignment_client_company_rra_candid_est_revenue',
    title: 'Revenue (SEC) (Position)',
    enabled: true,
    icon: 'monetization_on',
    section_id: 'assignment_client_company_rra_candid_est_revenue',
    filter_type: FilterType.NUMBER_RANGE,
    toggle_state: FilterToggleState.MUST_HAVE,
    unit: NumberUnitType.money,
    kw_prefix: 'assignment.client_company.rra_candid.est_revenue',
    rangeMeta: {
      min: 0,
      max: MONEY_RANGE_MAX,
      multiply: MILLION_UNITS,
      step: MONEY_RANGE_STEP,
      sub_label: 'in millions',
      unit: NumberUnitType.money,
      input_prefix: '$'
    }
  },
  assignment_billing_client_company_rra_candid_est_revenue: {
    id: 'assignment_billing_client_company_rra_candid_est_revenue',
    title: 'Revenue (SEC) (Billing)',
    enabled: true,
    icon: 'monetization_on',
    section_id: 'assignment_billing_client_company_rra_candid_est_revenue',
    filter_type: FilterType.NUMBER_RANGE,
    toggle_state: FilterToggleState.MUST_HAVE,
    unit: NumberUnitType.money,
    kw_prefix: 'assignment.billing_client_company.rra_candid.est_revenue',
    rangeMeta: {
      min: 0,
      max: MONEY_RANGE_MAX,
      multiply: MILLION_UNITS,
      step: MONEY_RANGE_STEP,
      sub_label: 'in millions',
      unit: NumberUnitType.money,
      input_prefix: '$'
    }
  },
  assignment_client_company_rra_candid_expenses: {
    id: 'assignment_client_company_rra_candid_expenses',
    title: 'Expenses (SEC) (Position)',
    enabled: true,
    icon: 'monetization_on',
    section_id: 'assignment_client_company_rra_candid_expenses',
    filter_type: FilterType.NUMBER_RANGE,
    toggle_state: FilterToggleState.MUST_HAVE,
    unit: NumberUnitType.money,
    kw_prefix: 'assignment.client_company.rra_candid.expenses',
    rangeMeta: {
      min: 0,
      max: MONEY_RANGE_MAX,
      multiply: MILLION_UNITS,
      step: MONEY_RANGE_STEP,
      sub_label: 'in millions',
      unit: NumberUnitType.money,
      input_prefix: '$'
    }
  },
  assignment_billing_client_company_rra_candid_expenses: {
    id: 'assignment_billing_client_company_rra_candid_expenses',
    title: 'Expenses (SEC) (Billing)',
    enabled: true,
    icon: 'monetization_on',
    section_id: 'assignment_billing_client_company_rra_candid_expenses',
    filter_type: FilterType.NUMBER_RANGE,
    toggle_state: FilterToggleState.MUST_HAVE,
    unit: NumberUnitType.money,
    kw_prefix: 'assignment.billing_client_company.rra_candid.expenses',
    rangeMeta: {
      min: 0,
      max: MONEY_RANGE_MAX,
      multiply: MILLION_UNITS,
      step: MONEY_RANGE_STEP,
      sub_label: 'in millions',
      unit: NumberUnitType.money,
      input_prefix: '$'
    }
  },
  rra_market_cap: {
    ui_cat_wl: ['Market Cap'],
    id: 'rra_market_cap',
    // kw_prefix: 'workexp.current.ciq.company.curr_financial_info.market_cap',
    kw_prefix: 'assignment.client_company.market_cap',
    title: 'Market Cap',
    section_id: 'rra_market_cap',
    enabled: false,
    icon: 'store',
    filter_type: FilterType.NUMBER_RANGE,
    toggle_state: FilterToggleState.MUST_HAVE,
    unit: NumberUnitType.money
  },
  [ASSIGNMENT_SELECTED_CANDIDATES_ROLE_DURATION]: {
    ui_cat_wl: [],
    id: ASSIGNMENT_SELECTED_CANDIDATES_ROLE_DURATION,
    kw_prefix: 'assignment.selected_candidates.role_duration',
    title: 'SC Role Length',
    section_id: ASSIGNMENT_SELECTED_CANDIDATES_ROLE_DURATION,
    enabled: false,
    icon: 'store',
    filter_type: FilterType.NUMBER_RANGE,
    toggle_state: FilterToggleState.MUST_HAVE,
    unit: NumberUnitType.year_no_multiplier,
  },
  rra_funding: {
    id: 'rra_funding',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Company Funding',
    section_id: 'rra_funding',
    enabled: false,
    icon: 'monetization_on',
    filter_type: FilterType.MULTI_SELECT,
    unit: NumberUnitType.money,
    kw_prefix: 'assignment.client_company.funding.series',
    search_field: 'company.funding.series'
  },
  company_product_cats: {
    ui_cat_wl: [],
    id: 'company_product_cats',
    kw_prefix: 'assignment.client_company.products.product_name',
    toggle_state: FilterToggleState.MUST_HAVE,
    enabled: true,
    title: 'Products',
    section_id: 'company_product_cats',
    icon: 'category',
    filter_type: FilterType.MULTI_SELECT,
    search_field: 'company.org_type'
  },
  company_subsidiaries: {
    ui_cat_wl: [],
    id: 'company_subsidiaries',
    kw_prefix: 'assignment.client_company.subsidiaries.company_name',
    toggle_state: FilterToggleState.MUST_HAVE,
    enabled: true,
    title: 'Subsidiaries',
    section_id: 'company_subsidiaries',
    icon: 'category',
    filter_type: FilterType.MULTI_SELECT,
    search_field: 'company.company_name'
  },
  parent_company_findem: {
    ui_cat_wl: [],
    id: 'parent_company_findem',
    kw_prefix: 'assignment.client_company.parent_companies.company_name',
    toggle_state: FilterToggleState.MUST_HAVE,
    enabled: true,
    title: 'Parent Company (Findem)',
    section_id: 'parent_company_findem',
    icon: 'category',
    filter_type: FilterType.MULTI_SELECT,
    search_field: 'company.company_name'
  },
  exit_info: {
    ui_cat_wl: [],
    id: 'exit_info',
    kw_prefix: 'assignment.client_company.exit_info.acquirer_entity_name',
    toggle_state: FilterToggleState.MUST_HAVE,
    enabled: true,
    title: 'Exit Info',
    section_id: 'exit_info',
    icon: 'category',
    filter_type: FilterType.MULTI_SELECT,
    search_field: 'company.company_name'
  },
  fmmagic: {
    ui_cat_wl: ['DEI', 'Superstar', 'Findem Magic'],
    id: 'fmmagic',
    toggle_state: FilterToggleState.MUST_HAVE,
    title: 'Findem Magic',
    section_id: 'fmmagic',
    enabled: false,
    icon: 'auto_fix_high',
    filter_type: FilterType.MULTI_SELECT,
  },
  // Combined Location
  combined_location: {
    id: 'combined_location',
    title: 'Location',
    enabled: true,
    icon: 'location_on',
    filter_type: FilterType.GROUPED_MULTI_SELECT,
    toggle_state: FilterToggleState.MUST_HAVE,
    section_id: 'combined_location',
  },
  // Combined Candid
  combined_candid: {
    id: 'combined_candid',
    title: 'Candid',
    enabled: true,
    icon: 'monetization_on',
    filter_type: FilterType.GROUPED_NUMBER_RANGE,
    toggle_state: FilterToggleState.MUST_HAVE,
    section_id: 'combined_candid',
  },
  assignment_client_company_investors_name: {
    id: 'assignment_client_company_investors_name',
    title: 'RRA Investors',
    enabled: true,
    icon: 'category',
    section_id: 'assignment_client_company_investors_name',
    filter_type: FilterType.MULTI_SELECT,
    toggle_state: FilterToggleState.MUST_HAVE,
    search_field: 'assignment.client_company.investors.name',
    kw_prefix: 'assignment.client_company.active.investor.name',
  },
  first_time_role_credential: {
    ui_cat_wl: ['First Time Role Credential'],
    id: 'first_time_role_credential',
    title: 'First Time Role Credential',
    enabled: true,
    icon: 'work',
    section_id: 'first_time_role_credential',
    filter_type: FilterType.MULTI_SELECT,
    toggle_state: FilterToggleState.MUST_HAVE,
  },
  ipo_experience: {
    ui_cat_wl: ['IPO Experience'],
    id: 'ipo_experience',
    title: 'IPO Experience',
    enabled: true,
    icon: 'lightbulb',
    section_id: 'ipo_experience',
    filter_type: FilterType.MULTI_SELECT,
    toggle_state: FilterToggleState.MUST_HAVE,
  },
};

export const UNKNOWN_SECTION_ID_ATTR_MAP: { [key: string]: string } = {
  'assignment_client_company_rra_candid_est_revenue': 'assignment.client_company.rra_candid.unknown_est_revenue:true',
  'assignment_billing_client_company_rra_candid_est_revenue': 'assignment.billing_client_company.rra_candid.unknown_est_revenue',
  'assignment_client_company_rra_candid_expenses': 'assignment.client_company.rra_candid.unknown_expenses:true',
  'assignment_billing_client_company_rra_candid_expenses': 'assignment.billing_client_company.rra_candid.unknown_expenses:true',
  [ASSIGNMENT_SELECTED_CANDIDATES_ROLE_DURATION]: 'assignment.selected_candidates.unknown_role_duration',
}

export const COMBINED_LOCATION_KEYS = [
  'position_assignment_region',
  POSITION_LOCATION_KEY,
  'assignment_client_company_region',
  'position_client_location_company_hq',
  'billing_client_location',
  'rra_office',
];

export const COMBINED_CANDID_KEYS = [
  'assignment_client_company_rra_candid_est_revenue',
  'assignment_billing_client_company_rra_candid_est_revenue',
  'assignment_client_company_rra_candid_expenses',
  'assignment_billing_client_company_rra_candid_expenses',
];

export const COMBINED_INDUSTRY_CODE_KEYS = [
  ASSIGNMENT_INDUSTRY_CODES_KEY,
  'assignment_industry_sector',
  'assignment_industry_practice',
  'assignment_industry',
];

// section which uses google location autocomplete api flow
export const LOCATION_FROM_GOOGLE_KEYS = [
  'position_client_location_company_hq',
  'billing_client_location',
];

export const getMainGroupObj = (field: string): IMainGroup => {
  const cat: IUICategory = DEFAULT_CAT_STATES[field];

  if (field === 'combined_location') {
    return {
      id: cat.id,
      title: cat.title,
      icon: cat.icon,
      identifier: cat.title,
      sidebar_attributes: COMBINED_LOCATION_KEYS,
      sidebar_group_sectionId_map: COMBINED_LOCATION_KEYS.reduce((acc, value) => {
        acc[value] = value;
        return acc;
      }, {} as NonNullable<IMainGroup['sidebar_group_sectionId_map']>),
      empty_message: cat.title,
      default_section_id: cat.id,
      placeholder: `Enter a ${cat.title}...`
    };
  } else if (field === 'combined_candid') {
    return {
      id: cat.id,
      title: cat.title,
      icon: cat.icon,
      identifier: cat.title,
      sidebar_attributes: COMBINED_CANDID_KEYS,
      sidebar_group_sectionId_map: COMBINED_CANDID_KEYS.reduce((acc, value) => {
        acc[value] = value;
        return acc;
      }, {} as NonNullable<IMainGroup['sidebar_group_sectionId_map']>),
      empty_message: 'Revenue, and Expenses',
      default_section_id: cat.id,
      placeholder: `Enter a ${cat.title}...`
    };
  } else if (field === ASSIGNMENT_INDUSTRY_CODES_KEY) {
    return {
      id: cat.id,
      title: cat.title,
      icon: cat.icon,
      identifier: cat.title,
      sidebar_attributes: COMBINED_INDUSTRY_CODE_KEYS,
      sidebar_group_sectionId_map: COMBINED_INDUSTRY_CODE_KEYS.reduce((acc, value) => {
        acc[value] = value;
        return acc;
      }, {} as NonNullable<IMainGroup['sidebar_group_sectionId_map']>),
      empty_message: cat.title,
      default_section_id: cat.id,
      placeholder: `Enter a ${cat.title}...`
    };
  } else {
    return {
      id: cat.id,
      title: cat.title,
      icon: cat.icon,
      identifier: cat.title,
      sidebar_attributes: [cat.id],
      empty_message: cat.title,
      default_section_id: cat.id,
      placeholder: `Enter a ${cat.title}...`
    };
  }
};

export const MAIN_GROUP: IMainGroup[] = Object.keys(DEFAULT_CAT_STATES).map((key: string) => {
  return getMainGroupObj(key);
});

export const INITIAL_FILTERS: string[] = [
  'role',
  'billing_client_company',
  'position_client',
  'end_date',
  'functional_area',
  'capability',
  ASSIGNMENT_INDUSTRY_CODES_KEY,
  'combined_location',
  'status',
  'assignment_label',
];

export const FMMAGIC_MACROS: string[] = [
  '668c4646a9db8ce01a9598df',
  '66887f7b3e9c0769d9ce5074',
  '6668dfb89ca9a408f22935cc',
  '5fe04757677375000707d2a6',
  '668c4304a9db8c14b09598da',
  '668c41aca9db8cdf9d9598d9',
  '668c41b519c5ddf9c44e6323',
  '5fe04ce7677375000707d2c1',
  '6668df9e9ca9a4807b2935cb',
  '6668dfa85555723d3dcc6403',
  '6668dcf29ca9a4703d2935c3',
  '66ed10aa277c5c2d34e9f130',
  '604b36f4a5ceb103af60fa61',
  '5fe05143677375000707d39d',
  '686c1ab614dcc345e2277233',
  '65624b10c3d166a04e906919',
  '682590edf826d19cd22033d6',
  '682586021efc649285418648',
  '68258574ea7d0882900b3d44',
  '68258a75cf68c4b482b89931',
  '68258b25c280423d7015bf01',
  '68259219cf68c4c6ebb8993e',
  '682589e5f826d113442033c5',
  '6825879ff826d17e762033c4',
  '6825861984fbc2151e85f021',
  '6825917bf826d1ba9e2033d9',
  '68258940c28042be8f15beff',
  '6827ac14c280422b2715bf8f',
  '6827c76484fbc2668c85f0bb',
  '6827ac0bea7d0863ba0b3dde',
  '6827c6e9f826d1c25a203454',
  '6827abfa1efc641da44186d1',
  '6827ac201efc6472404186d2',
  '6827a45c84fbc22c8685f0b4',
  '6827a60af826d15276203452',
  '6827abee84fbc2e59285f0b5',
  '6827ac2ccf68c4185bb899b6',
  '6866b7047392b237afc4769b',
  '6952cbf27c6b7ee98ec1a15d', // Still in Seat
  '6952cb389bc0ed4e7ba41528', // No Longer in Seat
  '6952cc61508bb870ad29b84d', // New Role At Seated Company
]

const PREFERRED_SHOW_MORE_FIELDS_ORDER: string[] = [
  'company_keyword',
  ASSIGNMENT_SELECTED_CANDIDATES_ROLE_DURATION,
  'fmmagic',
  'assignment_position_client_company_stock_index',
  'assignment_billing_client_company_stock_index',
  'assignment_billing_client_company_parent_company_name',
  'assignment_client_company_parent_company_name',
  'assignment_type',
  'start_date',
  'assignment_client_company_investors_name',
  // 'first_time_role_credential',
  // 'ipo_experience',
  'assignment_org_type',
  'private_capital_type_client',
  'rra_funding',
  'rra_company_size',
  'rra_revenue',
  'combined_candid',
  'rra_market_cap',
  'company_biz_model',
  'confidentiality',
  'service_line_group',
  'service_line_type',
  'reporting_level',
  'lead_consultant',
  'person_is_active',
  // 'person_capability',
  // 'person_region' - used in combined location,
  // 'rra_office' - used in combined location,
  // 'person_hub' - used in combined location,
  'past_or_current_company_industry',
  'company_competitors',
  'parent_company_findem',
  'company_subsidiaries',
  'company_product_cats',
];

const SHOW_MORE_FILTER_EXCLUDED_FIELDS = new Set<string>([
  ...INITIAL_FILTERS,
  ...COMBINED_LOCATION_KEYS,
  ...COMBINED_CANDID_KEYS,
  ...COMBINED_INDUSTRY_CODE_KEYS,
  'company_by_id',
  'exit_info',
  'first_time_role_credential',
  'ipo_experience',
  'person_capability',
  'person_industry',
  'person_region',
  'project_type',
]);

export const SHOW_MORE_FIELDS: string[] = [
  ...PREFERRED_SHOW_MORE_FIELDS_ORDER.filter((field) => (
    Boolean(DEFAULT_CAT_STATES[field]) && !SHOW_MORE_FILTER_EXCLUDED_FIELDS.has(field)
  )),
  ...Object.keys(DEFAULT_CAT_STATES).filter((field) => (
    !PREFERRED_SHOW_MORE_FIELDS_ORDER.includes(field)
    && !SHOW_MORE_FILTER_EXCLUDED_FIELDS.has(field)
  )),
];

export const PROJECT_FIELDS: string[] = [
  'start_date',
  'end_date',
  'status',
  'functional_area',
  'role',
  'location',
  'position_client',
  'billing_client_company',
  'past_or_current_company_industry',
  'company_keyword',
  'assignment_org_type',
  'private_capital_type_client',
  'rra_revenue',
  'rra_funding',
  'service_line_group',
  'assignment_type',
  'lead_consultant',
  // 'industry_code',
];

export const PERSON_FIELDS: string[] = [
  'service_line_type',
  'person_industry',
  'person_is_active',
  'reporting_level',
  'confidentiality',
  // 'person_capability',
  'person_region',
  'rra_office',
  'person_hub',
];

export const COMPANY_FIELDS: string[] = [
  'company_biz_model',
  'company_competitors',
  'rra_company_size',
  'rra_market_cap',
  'company_product_cats',
  'parent_company_findem',
  'fmmagic',
  'company_subsidiaries',
  'exit_info',
];

export const ASSIGNMENT_STATUS_VALUES = [
  'Completed',
  'Open',
  'Reopened',
  'New',
  'Resolved',
  'Suspended',
  'Cancelled',
  // 'Awaiting AM to Complete',
  // 'Awaiting Approval',
  // 'Awaiting RHCD to Complete',
  // 'Awaiting RHCD to Open',
  // 'CA',
  // 'CLO',
  // 'CO',
  // 'Closed',
  // 'Delete',
  // 'N',
  // 'Never Start',
  // 'OAM',
  // 'OP',
  // 'RS',
  // 'SU',
];

export const ASSIGNMENT_TYPE_VALUES = [
  'Full Search',
  'Pre-Search',
  'Open/Close',
  'Consulting',
  'Special Project',
];

export interface IGroupedMainGroup {
  groups: IMainGroup[];
  title: string;
  id: string;
}



// export const GROUPED_MAIN_GROUP: IGroupedMainGroup[] = [
//   {
//     id: 'project',
//     title: 'Frequently Used',
//     groups: PROJECT_FIELDS.map((field: string) => {
//       return getMainGroupObj(field);
//     })
//   },
//   {
//     id: 'person',
//     title: 'RRA Data',
//     groups: PERSON_FIELDS.map((field: string) => {
//       return getMainGroupObj(field);
//     })
//   },
//   {
//     id: 'company',
//     title: 'Company Data',
//     groups: COMPANY_FIELDS.map((field: string) => {
//       return getMainGroupObj(field);
//     })
//   }
// ];
